import {useState} from 'react';
import {ConfiguracaoBaratinhasDTO} from '..//dtos/ConfiguracaoBaratinhasDTO';
import {PodeResgatarBaratinhasDTO} from '../dtos/PodeResgatarBaratinhasDTO';
import {api} from '../services/api';
import {
  calcDescontoBaratinhas,
  parseValorResgate,
} from '../utils/payments/baratinhas';

export interface BaratinhasState {
  usaBaratinhas: boolean;
  descontoBaratinhas: number;
  configuracaoBaratinhas: ConfiguracaoBaratinhasDTO;
  handleAplicaBaratinhas: (value: boolean) => void;
  handleRemoveBaratinhas: () => void;
  handleCalculaDescontoBaratinhas: (opts: {
    cotacaoCents: number;
    qntdeBaratinhas: number;
    limiteRegaste: number;
  }) => void;
  handleSetDescontoBaratinhas: (desconto: number) => void;
  handleConfiguraBaratinhas: () => Promise<void>;
}

export function useBaratinhas(): BaratinhasState {
  const [usaBaratinhas, setUsaBaratinhas] = useState(false);
  const [descontoBaratinhas, setDescontoBaratinhas] = useState(0);
  const [configuracaoBaratinhas, setConfiguracaoBaratinhas] =
    useState<ConfiguracaoBaratinhasDTO>({} as ConfiguracaoBaratinhasDTO);

  function handleAplicaBaratinhas(value: boolean) {
    setUsaBaratinhas(value);
  }

  function handleRemoveBaratinhas() {
    setUsaBaratinhas(false);
    setDescontoBaratinhas(0);
  }

  function handleCalculaDescontoBaratinhas({
    cotacaoCents,
    qntdeBaratinhas,
    limiteRegaste,
  }: {
    cotacaoCents: number;
    qntdeBaratinhas: number;
    limiteRegaste: number;
  }) {
    const desconto = calcDescontoBaratinhas(
      cotacaoCents,
      limiteRegaste,
      qntdeBaratinhas,
    );
    setDescontoBaratinhas(desconto);
    if (desconto <= 0) {
      setUsaBaratinhas(false);
    }
  }

  function handleSetDescontoBaratinhas(desconto: number) {
    setDescontoBaratinhas(desconto);
    if (desconto <= 0) {
      setUsaBaratinhas(false);
    }
  }

  async function handleConfiguraBaratinhas() {
    try {
      const {data} = await api.get<PodeResgatarBaratinhasDTO>(
        '/podeResgatar',
      );

      const limiteResgate = data.minimo;
      const valorResgateReais = parseValorResgate(data.valor_resgate);
      const cotacaoCents =
        limiteResgate > 0 ? (valorResgateReais * 100) / limiteResgate : 0;

      setConfiguracaoBaratinhas({
        cotacaoCents,
        limiteResgate,
      });
    } catch (error) {
      throw new Error();
    }
  }

  return {
    usaBaratinhas,
    descontoBaratinhas,
    configuracaoBaratinhas,
    handleAplicaBaratinhas,
    handleRemoveBaratinhas,
    handleCalculaDescontoBaratinhas,
    handleSetDescontoBaratinhas,
    handleConfiguraBaratinhas,
  };
}
